export interface IProps {
  children?: JSX.Element
}

export enum LAYOUT_NAME {
  BLANK = 'BLANK',
  ADMIN = 'ADMIN',
  AUTHEN = 'AUTHEN'
}
